export default {
  v3OfficialTopUpCenterTitle: '官網儲值中心',
  v3OfficialTopUpCenterKeyword: '官網儲值中心',
  v3OfficialTopUpCenterDescription: '官網儲值中心',
  v3SafeAndFast: '安全無風險 極速到帳',
  v3Shop: '商城',
  v3ShoppingCart: '購物車',
  v3MembershipCenter: '權益中心（大會員中心）',
  v3Login: '登錄',
  v3Account: '帳號',
  v3EnterAccountName: '請輸入帳號名稱',
  v3Password: '密碼',
  v3EnterPassword: '請輸入密碼',
  v3ForgotPassword: '忘記密碼',
  v3EnterUID: '請輸入UID',
  v3OTP: 'OTP',
  v3EnterOTP: '請輸入OTP',
  v3SelectTopUpCharacter: '選擇儲值角色',
  v3SelectServer: '請選擇伺服器',
  v3Confirm: '確認',
  v3CharacterNotFound:
    '若找不到角色，請嘗試先在遊戲APP中登入角色再來登錄儲值頁面或聯繫客服',
  v3Logout: '登出',
  v3SwitchAccount: '切換帳號',
  v3MyCoupons: '我的優惠券',
  v3BenefitsCenter: '權益中心',
  v3TopUpBenefits: '儲值福利',
  v3MoreSettings: '更多設置',
  v3RememberLoginStatus: '記住我的登錄狀態',
  v3OrderQuery: '訂單查詢',
  v3ContactCustomerService: '聯繫客服',
  v3LoginWithApp: '使用APP登錄',
  v3ChooseOtherLoginMethod: '選擇其他登錄方式',
  v3ConnectingToGameApp: '正在連接遊戲APP',
  v3EnsureGameInstalled:
    '請確保該設備已安裝遊戲。如果遊戲為未回應或登錄失敗，請從應用商店將遊戲升級到最新版本或更換其他流覽器。',
  v3OpenGame: '打開遊戲',
  v3DownloadGame: '下載遊戲',
  v3UpdateGameIfOpenFails: '若打開遊戲失敗，請從應用商店將遊戲升級到最新版本',
  v3ClickToDownloadLatestVersion: '或可點擊下載遊戲按鈕，下載最新版本',
  v3LoggingIntoOfficialTopUpCenter: '您正在登錄【官網儲值中心】',
  v3CurrentAccount: '當前帳號：xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter: '歡迎使用官網儲值中心',
  v3OfficialAuthorizedLogin: '官方授權登錄，安全無風險',
  v3TermsOfService: '服務條款',
  v3PrivacyPolicy: '隱私政策',
  v3ThirdPartySocialAccountDescription: '協力廠商社交帳號說明',
  v3BindSocialAccountInGameFirst:
    '請先在遊戲內用戶中心完成社交帳號綁定，再使用綁定的社交帳號進行登錄。',
  v3FirstTopUp15PercentOff: '首次儲值最高享15%OFF',
  v3MoreTopUpRebates: '更多儲值返利送不停',
  v3LoginToViewOffers: '登錄以查看優惠',
  v3TopUpEnvironmentChecking: '儲值環境檢測中……',
  v3SafeToUse: '安全，可放心使用',
  v3LimitedTimeBenefits: '限時福利',
  v3EventRules: '活動規則',
  v3MoreEvents: '更多活動',
  v3Claim: '領取',
  v3Completed: '已完成',
  v3GoTo: '前往',
  v3ViewDetails: '查看詳情',
  v3RecommendedProducts: '推薦商品',
  v3SearchProductName: '搜索商品名稱',
  v3AllCategories: '全部分類',
  v3PopularSort: '熱門排序',
  v3PriceAscending: '價格升序',
  v3PriceDescending: '價格降序',
  v3DiamondBonus10Percent: '鑽石加碼10%',
  v3YuanbaoBonus10Percent: '元寶加碼10%',
  v3ExtraBonus10Percent: '額外贈送10%',
  v3FirstTopUpDouble: '首儲雙倍',
  v3FirstExtraBonus: '首次額外贈送',
  v3ProductDetails: '商品詳情',
  v3AddToCart: '加入購物車',
  v3AddedToCart: '已添加購物車',
  v3BuyNow: '立即購買',
  v3NoItemsInCart: '您還沒選購商品至購物車',
  v3SelectedItemsN: '已選商品（${n}）',
  v3RemoveFromCart: '是否移出購物車',
  v3Yes: '是',
  v3No: '否',
  v3LimitOnePerPurchase: '該商品每次限購一件',
  v3ItemPrice: '商品價格',
  v3Tax: '稅',
  v3ExtraGift: '額外贈送',
  v3Total: '合計',
  v3ProceedToPayment: '去支付',
  v3SelectCoupon: '選擇優惠券',
  v3UnavailableCoupons: '不可用優惠券',
  v3OneCouponPerOrder: '每筆訂單限用一張',
  v3DiscountCoupon: '折扣優惠券',
  v3ThresholdCoupon: '滿減優惠券',
  v3MinSpendCoupon: '滿xx USD可用',
  v3MaxDiscountCoupon: '最多優惠xxxx USD',
  v3LimitedChannel: '限定管道可用',
  v3AllChannels: '所有管道可用',
  v3SpecificProducts: '指定商品可用',
  v3AllProducts: '所有商品可用',
  v3NotYetTimeToUse: '未到使用時間',
  v3Expired: '已過期',
  v3Used: '已使用',
  v3ValidityPeriod: '有效期：',
  v3ConfirmUse: '確認使用',
  v3ChangeProduct: '更換商品',
  v3ConfirmPaymentOrder: '確認支付訂單',
  v3StoredValueRole: '儲值角色',
  v3TotalNProducts: '共${n}個商品',
  v3SelectPaymentMethod: '選擇支付方式',
  v3PayNow: '立即支付',
  v3MorePaymentMethods: '更多支付方式',
  v3NoAvailablePaymentMethodContactSupport: '找不到可用的支付方式？聯繫客服',
  v3AvailableCoupons: '可用優惠券',
  v3Extra10Percent: '加碼10%',
  v3LastSelection: '上次選擇',
  v3RecommendedUsage: '推薦使用',
  v3PopularChoice: '熱門選擇',
  v3PaymentSuccess: '支付成功',
  v3PaymentFailure: '支付失敗',
  v3TopUpFailureMessage:
    '非常抱歉儲值失敗了，請您嘗試重新提交訂單，或通過下方的客服按鈕聯繫我們',
  v3Game: '遊戲',
  v3UID: 'UID',
  v3OrderNumber: '訂單編號',
  v3ProductContent: '商品內容',
  v3ViewProductDetails: '查看商品詳情',
  v3PaymentMethod: '支付方式',
  v3Complete: '完成',
  v3TopUpAgain: '再儲一筆',
  v3FriendlyReminderSaveOrderInfo:
    '溫馨提示：截圖保存訂單資訊，方便我們快速處理您的訂單',
  v3RechargeAgain: '重新儲值',
  v3TransactionInProgress: '交易進行中',
  v3CompletePaymentInChannel: '請前往支付管道完成訂單支付',
  v3RestAssuredFastDeliveryAfterPayment:
    '放心，當我們收到訂單支付結果後會最快速度給您發放商品道具',
  v3SaveOrderInfoForProgress: '您可以截圖保存訂單資訊以便確認交易進度',
  v3PaymentCompleted: '我已完成支付',
  v3AddToHomeScreen: '添加到主屏',
  v3AddShortcutForBonus: '添加桌面快捷方式，領取額外獎勵',
  v3ShareSuccess: '分享成功',
  v3ShareFailure: '分享失敗',
  v3RewardClaimed: '領獎成功',
  v3RewardClaimFailed: '領獎失敗',
  v3EventNotStarted: '活動未開始',
  v3EventEnded: '活動已結束',
  v3ClickSelectCoupon: '點擊選擇優惠券',
  v3CouponsRecommendedUsed: '已使用推薦的優惠券',
  v3CouponsSelected: '已選擇優惠券',
  v3NoCouponsAvaliable: '無可用優惠券',
  v3SupplementStatus: '狀態',
  v3SupplementNormal: '正常',
  v3SupplementBanned: '已封禁',
  v3SupplementPendingPayment: '待補款',
  v3SupplementSwitchCharacter: '切換角色',
  v3SupplementAccountInfoInvalid: '帳號信息失效',
  v3SupplementContactGSForTopUpLink: '請先聯繫GS獲取儲值鏈接',
  v3SupplementTopUpCompleted: '已完成儲值：',
  v3SupplementTotalRefundOrders: '共{}筆退款訂單',
  v3SupplementPendingSupplementAmount: '待補款金額：',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    '帳號/角色正常，不需要補款',
  v3SupplementEnjoyYourGame: '祝您遊戲愉快!!',
  v3SupplementOrderInformation: '訂單信息',
  v3SupplementPendingPaymentAmount: '待支付金額：',
  v3LookUpCouponRule: '查看優惠券發放規則',
  v3SwitchOldVersion: '切換至舊支付平台',
  v3FirstTopUpGiveaway: '首儲\n贈送',
  v3SecureConnection: '安全連線中',
  v3RequestTimeOut: '載入逾時，請稍後再試',
  v3ConfirmLeave: '確定要離開嗎？',
  v3NoSubmitOrder: '您的購物車還沒結帳，離開後可能會錯過喜歡的商品喔！',
  v3ContinueSubmit: '繼續購物',
  v3LeaveSubmit: '離開',
  v3RecentBug: '最近購買',
  v3ScanCodeLogin: '掃碼登錄',
  v3BindRole: '綁定角色',
  v3ScanLoading: '加載中...',
  v3ScanExpired: '二維碼已過期',
  v3ScanRefreshClick: '請點擊刷新重試',
  v3ScanRefreshTip: '請刷新後重新掃碼授權',
  v3ScanRefresh: '刷新',
  v3ScanSucc: '掃描成功',
  v3ScanAuth: '請在手機上確認授權',
  v3ScanAuthSuccess: '授權成功',
  v3ScanAuthSuccessTip: '登錄中...',
  v3ScanUnauthorized: '未授權',
  v3ScanRefreshTip2: '請打開遊戲登錄後掃碼登錄',
  v3ScanGuide: '掃碼指引',
  v3ScanLoginError: '登錄異常，請刷新後重試',
  v3PwaTapShareOrMenuIcon: '點擊瀏覽器工具列的「分享」或「選單」圖示',
  v3PwaFindAndTapAddToHomeScreen: '在選項中找到並點擊「加入主畫面」',
  v3ThirdPartyLogin: '第三方登錄',
  v3NoMyLoginMethod: '沒有我的登錄方式？',
  v3AccountPasswordLogin: '請輸入賬號綁定游戲角色',
  v3LaunchFromDesktopAndRewardToMailbox: '請從桌面啟動\n選擇角色後獎勵將發送至信箱',
  v3ClaimSuccessCheckMailbox: '領取成功\n請前往遊戲內信箱查看',
  v3ExclusiveProductTip: '購物車已有此商品，請移除後再加購。',
  v3LifeLimitProductTip: '此商品無法多次加入購物車\n一次只能加入一個',
  v3Notice: '注意',
  v3LifeLimitAddToCartTip: '<span style="font-weight: bold;text-decoration: underline;">【productName】終身限購1次</span>\n僅第一筆成功支付的訂單可獲得【productName】\n若產生額外成功支付，自第二筆訂單起\n<span style="font-weight: bold;text-decoration: underline;;">將統一發放【191999星石】</span>',
  v3LifeLimitCancelAddToCart: '取消加入購物車',
  v3LifeLimitConfirmAddToCart: '確認，繼續購買',
  v3LifeLimitCancelBuy: '取消購買',
  v3LifeLimitSubmitProductContent: '購物車中包含商品<span style="font-weight: bold;text-decoration: underline;">【productName】</span>\n<span style="font-weight: bold;text-decoration: underline;" > 此商品終身限購1次</span>\n僅第一筆成功支付的訂單可獲得【productName】\n若產生額外成功支付，<span style="font-weight: bold;text-decoration: underline;">自第二筆訂單起將統一發放【191999星石】</span>',
  v3NoAvailableProducts: '當前角色無可購商品\n請選擇10級以上的角色並確保角色在線',
};
